const startsWith = require('lodash/startsWith');
const isMobile = require('is-mobile');
const imagePreview = require('./imagePreview');
const Lang = require('lang');

const to_array = function(list) {
  return [].slice.call(list, 0);
}

const remove = function(el) {
  el.remove();
};

const clearInputFile = function(input) {
  input.value = '';
  input.type = 'text';
  input.type = 'file';
}

function FilePicker() {
  const allFilePickers = to_array(document.querySelectorAll('.file-picker'));
  allFilePickers.forEach((elFilePicker) => {
    const prefix = elFilePicker.getAttribute('data-prefix');
    const filePickers = to_array(document.querySelectorAll(`.${prefix}-file-picker`));
    const mobileFilePickers = to_array(document.querySelectorAll(`.${prefix}-file-picker-mobile`));

    if(!isMobile()) {
      filePickers.length && filePickers.forEach((filePicker) => {
        filePickerStart(filePicker, prefix);
      });
      mobileFilePickers.length && mobileFilePickers.forEach(remove);
    } else {
      filePickers.length && filePickers.forEach(remove);
    }
  });
}

/**
 * Verifica se o tamanho do arquivo que esta no input excedeu o limite
 *
 * @param input
 *
 * @return {Boolean}
 */
function validateInputFileSize(input) {
  const fileSize = input.files[0].size / 1024 / 1024;
  if(fileSize > window.uploadMaxSize) {
    bootbox.alert({
      title: Lang.get('js/src/functions/FilePicker.ops'),
      message: Lang.get('js/src/functions/FilePicker.maximum_file_size_exceeded', {max_size: window.uploadMaxSize}),
      size: 'small'
    });
    clearInputFile(input);
    return false;
  }
  return true;
}

function filePickerStart(filePicker, prefix) {
  const inputs       = to_array(filePicker.querySelectorAll('input[type="file"]'));
  const labels       = to_array(filePicker.querySelectorAll(`.${prefix}-file-picker__add`));
  const removeButton = filePicker.querySelector(`.${prefix}-file-picker__add--remove`);
  const zoomButton   = filePicker.querySelector(`.${prefix}-file-picker__zoom`);
  let image          = filePicker.querySelector(`.${prefix}-file-picker__image`);
  const fileName     = filePicker.querySelector(`.${prefix}-file-picker__file-name`);

  const showRemoveButton = function() {
    labels.forEach(function(label) {
      label.classList.add('hidden');
    });
    removeButton.classList.remove('hidden');
  };

  const changeImageSrc = function(src) {
    if(!image) {
      image = document.createElement('img');
      image.className = `${prefix}-file-picker__image file-picker__image`;
      filePicker
        .querySelector(`.${prefix}-file-picker__container`)
        .appendChild(image);
    }

    image.src = src;
    zoomButton.href = src;
    image.classList.remove('hidden');
    zoomButton.classList.remove('hidden');
  }
  /**
   * Método que adiciona o valor true ou false para
   * a input do tipo hidden que indica a escolha de
   * uma nova  imagem para ser utilizada
   *
   * @param  {Boolean} added
   *
   * @return {avoid}
   */
  const changeInputImageChose = function (removeImage = false) {
    const inputElement = document.getElementById(`${prefix}-add-image-input-confirmation`);
    if (inputElement) {
      if (removeImage == true) {
        inputElement.value = true;
        return;
      }
      inputElement.value = false;
    }
  };

  removeButton.addEventListener('click', function() {
    labels.forEach(function(label) {
      label.classList.remove('hidden');
    });
    inputs.forEach(clearInputFile);
    removeButton.classList.add('hidden');
    fileName.classList.add('hidden');
    if(image) {
      image.classList.add('hidden');
      image.src = '';
    }
    if (typeof(zoomButton) != 'undefined' && zoomButton != null) {
      zoomButton.href = '';
      zoomButton.classList.add('hidden');
    }
    if(filePicker.classList.contains('has-file')) {
      const idImagemInput = filePicker.querySelector('#idImagem');
      clearInputFile(idImagemInput);
    }
    changeInputImageChose(true);
  });

  if(filePicker.classList.contains('has-file')) {
    showRemoveButton();
  }

  inputs.forEach(function(input) {
    const name = input.name;
    switch (name) {
      case `${prefix}Imagem` || `${prefix}Image`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          filePicker.classList.remove(`${prefix}-file-picker--error`);

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          imagePreview(input.files[0])
            .done(function(result) {
              changeImageSrc(result)
              showRemoveButton();
              changeInputImageChose();
              if(removeFileInput) {
                removeFileInput.parentNode.removeChild(removeFileInput)
              }
            });
        });
        break;
      case `${prefix}Pdf`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          filePicker.classList.remove(`${prefix}-file-picker--error`);

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          if (input.files[0].type == 'application/pdf') {
            fileName.innerText = input.files[0].name;
            fileName.classList.remove('hidden');
            fileName.href = '';
            if(removeFileInput) {
              removeFileInput.parentNode.removeChild(removeFileInput)
            }
            showRemoveButton();
          } else {
            bootbox.alert({
              title: Lang.get('js/src/functions/FilePicker.ops'),
              message: Lang.get('js/src/functions/FilePicker.invalid_pdf'),
              size: 'small'
            });
            clearInputFile(input);
          }
        });
        break;
      case `${prefix}Txt`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          filePicker.classList.remove(`${prefix}-file-picker--error`);

          fileName.innerText = input.files[0].name;
          fileName.classList.remove('hidden');
          fileName.href = '';
          if(removeFileInput) {
            removeFileInput.parentNode.removeChild(removeFileInput)
          }
          showRemoveButton();
        });
        break;
      case `${prefix}Excel`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          filePicker.classList.remove(`${prefix}-file-picker--error`);

          fileName.innerText = input.files[0].name;
          fileName.classList.remove('hidden');
          fileName.href = '';
          if(removeFileInput) {
            removeFileInput.parentNode.removeChild(removeFileInput)
          }
          showRemoveButton();
        });
        break;
      case `${prefix}Ret`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          filePicker.classList.remove(`${prefix}-file-picker--error`);

          fileName.innerText = input.files[0].name;
          fileName.classList.remove('hidden');
          fileName.href = '';
          if(removeFileInput) {
            removeFileInput.parentNode.removeChild(removeFileInput)
          }
          showRemoveButton();
        });
        break;
      case `${prefix}Xml`:
        input.addEventListener('change', function(e) {
          if (!validateInputFileSize(input)) {
            return;
          };

          const removeFileInput = filePicker.querySelector(`#${prefix}-remove-file`);
          filePicker.classList.remove(`${prefix}-file-picker--error`);

          fileName.innerText = input.files[0].name;
          fileName.classList.remove('hidden');
          fileName.href = '';
          if(removeFileInput) {
            removeFileInput.parentNode.removeChild(removeFileInput)
          }
          showRemoveButton();
        });
        break;
    }
  });
};

exports.init = FilePicker;

